module.exports = __webpack_public_path__ + "static/img/dsjyx_img_illtration.fdbc9ae.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/dsjyx_img_illtration.png
// module id = 2R7U
// module chunks = 0